import Component from '../inherited/Component'

export default class ScrollControl extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.links = Array.from(
      this._elem.querySelectorAll('[data-link]')
    )

    this.images = Array.from(
        this._elem.querySelectorAll('[data-image]')
    )

    this.blocks = Array.from(
      this._elem.querySelectorAll('[data-scroll-block]')
    )

    this.header = this._elem.querySelector('[data-scroll-header]')
    this.scrollElem = this._elem.querySelector('[data-scroll-container]')
    this.scrollDirection = 'down'
    this.lastScrollY = 0
    this.currentScrollY = window.scrollY
    this.lock = true
  }

  _getVisibleBlocks () {
    return this.blocks.filter((elem) => elem.offsetParent !== null)
  }

  _setVisibleBlock () {
    this.findMostVisibleElement(this._getVisibleBlocks()).then(mostVisibleElement => {
      const index = this._getVisibleBlocks().indexOf(mostVisibleElement)

      this.links.forEach(link => link.classList.remove('is-active'))
      this.images.forEach(image => image.classList.remove('is-active'))
      const activeLink = this.links[index];
      const activeImage = this.images[index];

      if(!activeLink) {
        return;
      }

      activeLink.classList.add('is-active')

      if(activeImage) {
          activeImage.classList.add('is-active')
      }

      activeLink.parentElement.scroll({
        top: 0,
        left: index === 0 ? 0 : activeLink.offsetLeft,
        behavior: 'smooth',
      });
    })
  }

  mount() {

    if (this._options.enableWhen && !this._addedListener) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
        }
      }, { passive: true })
      this._addedListener = true
    }

    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      return false
    }

    if (matchMedia(`only screen and (max-width: 834px)`).matches) {
      this._elem.style.setProperty('--offset', `${this.header.offsetHeight + 1}px`)
    }

    window.addEventListener('scroll', () => {
      this._setVisibleBlock()
    })

    if (matchMedia(`only screen and (max-width: 834px)`).matches) {
      this.scrollElem.addEventListener('scroll', () => {
        this._setVisibleBlock()
      })
    }

    this.links.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault()

        const index = link.dataset.link;

        const block = this._getVisibleBlocks().find((elem) => elem.dataset.scrollBlock === index)

        let offset = 0

        if (matchMedia(`only screen and (max-width: 834px)`).matches) {
          offset = this.header.offsetHeight
        }
        
        let bodyRect = document.body.getBoundingClientRect().top
        let elementRect = block.getBoundingClientRect().top
        let elementPosition = elementRect - bodyRect
        let offsetPosition = elementPosition - offset
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      })
    })
  }

  findMostVisibleElement(elements) {
    let maxVisibility = 0
    let mostVisibleElement = null

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > maxVisibility) {
            maxVisibility = entry.intersectionRatio
            mostVisibleElement = entry.target
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    )

    elements.forEach(element => observer.observe(element))

    return new Promise(resolve => {
      const checkVisibilityInterval = setInterval(() => {
        if (mostVisibleElement !== null) {
          clearInterval(checkVisibilityInterval)
          observer.disconnect()
          resolve(mostVisibleElement)
        }
      }, 100)
    })
  }
}
